export const displayId = (num) => {
    const id = `${num}`.padStart(6, "0");
    return `Q-${id}`;
};
